<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>shopping_cart</md-icon>
        </div>
        <h4 class="title">Vendors</h4>
      </md-card-header>
      <md-card-content>
        <md-toolbar md-elevation="0" class="md-transparent md-dense">
          <div class="md-toolbar-section-end">
            <md-button
              class="md-icon-button md-dense md-primary md-round"
              @click="newVendor"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top">Add Vendor</md-tooltip>
            </md-button>
          </div>
        </md-toolbar>
        <md-table v-model="vendors" @md-selected="viewVendor">
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
          >
            <md-table-cell md-label="Company">
              <a href="#" @click.stop="viewVendor(item)">{{ item.company }}</a>
            </md-table-cell>
            <md-table-cell md-label="Country">
              {{ item.country }}
            </md-table-cell>
            <md-table-cell class="text-right">
              <md-button
                class="md-just-icon md-simple md-danger "
                @click.stop="deleteVendor(item)"
              >
                <md-icon>delete</md-icon>
                <md-tooltip md-direction="top">Delete</md-tooltip>
              </md-button>
              <md-button
                class="md-just-icon md-simple md-success"
                @click.stop="viewVendor(item)"
              >
                <md-icon>visibility</md-icon>
                <md-tooltip md-direction="top">View</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>

          <md-table-empty-state
            md-label="Let's Shop..."
            :md-description="`Add a Vendor.`"
          >
            <md-button class="md-primary md-raised" @click="newVendor"
              >Add Vendor</md-button
            >
          </md-table-empty-state>
        </md-table>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  props: ["vendors"],

  data() {
    return {};
  },

  components: {},

  methods: {
    newVendor() {
      this.$emit("addVendor");
    },

    viewVendor(vendor) {
      this.$emit("viewVendor", vendor);
    },

    deleteVendor(vendor) {
      this.$emit("deleteVendor", vendor);
    }
  },

  watch: {},

  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-switch {
  margin: 0;
}
</style>
